<template>
    <div class="tsa-invoice-dialog" v-show="visible" :class="{ 'is-simple': type === 'simple' }">
        <div class="mask" @click="handleClose"></div>
        <div class="dialog-content" :style="{ width: width }">
            <div class="dialog-header" v-if="type !== 'simple'">
                <span class="title">{{ title }}</span>
                <span class="close-btn" @click="handleClose">
                    <span class="el-icon-close"></span>
                </span>
            </div>
            <div class="dialog-header-simple" v-else>
                <span class="title">{{ title }}</span>
            </div>
            <div class="dialog-body">
                <slot></slot>
            </div>
            <div class="dialog-footer" :class="{ 'footer-center': footerAlign === 'center' }" v-if="showFooter">
                <template v-if="type === 'simple'">
                    <button class="btn btn-confirm btn-full" @click="handleConfirm" :disabled="confirmDisabled">{{ confirmText }}</button>
                </template>
                <template v-else>
                    <button class="btn" :class="showConfirm ? 'btn-cancel' : 'btn-confirm btn-full'" @click="handleCancel">{{ cancelText }}</button>
                    <button class="btn btn-confirm" @click="handleConfirm" :disabled="confirmDisabled" v-if="showConfirm">{{ confirmText }}</button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InvoiceDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '560px'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '确定'
        },
        showConfirm: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        confirmDisabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'default',
            validator: val => ['default', 'simple'].includes(val)
        },
        footerAlign: {
            type: String,
            default: 'right',
            validator: val => ['right', 'center'].includes(val)
        }
    },
    methods: {
        handleClose () {
            this.$emit('update:visible', false)
            this.$emit('close')
        },
        handleCancel () {
            this.$emit('cancel')
            this.$emit('update:visible', false)
        },
        handleConfirm () {
            if (this.confirmDisabled) return
            this.$emit('confirm')
        }
    }
}
</script>

<style lang="less" scoped>
.tsa-invoice-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(13, 13, 13, 0.5);
        z-index: 1;
    }

    .dialog-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 16px;
        box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
        z-index: 2;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        max-height: 90vh;
    }

    .dialog-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px 28px 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);

        .title {
            font-size: 18px;
            font-weight: bold;
            color: #0F172A;
            line-height: 28px;
        }

        .close-btn {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            cursor: pointer;
            transition: all 0.2s;

            .el-icon-close {
                font-size: 14px;
                color: #000;
            }

            &:hover {
                background: rgba(0, 0, 0, 0.04);
                border-color: rgba(0, 0, 0, 0.15);

                .el-icon-close {
                    color: #333;
                }
            }
        }
    }

    .dialog-header-simple {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 28px 28px 0;

        .title {
            font-size: 20px;
            font-weight: bold;
            color: #0F172A;
            line-height: 28px;
        }
    }

    .dialog-body {
        flex: 1;
        overflow-y: auto;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 12px 28px 28px;
        gap: 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.06);

        &.footer-center {
            justify-content: center;

            .btn {
                flex: 1;
            }
        }

        .btn {
            height: 44px;
            border-radius: 8px;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            transition: all 0.2s;
            border: none;
            outline: none;
        }

        .btn-cancel {
            width: 130px;
            background: #fff;
            border: 1px solid #e0e0e0;
            color: #666;

            &:hover {
                color: #3B7DFF;
                border-color: #3B7DFF;
            }
        }

        .btn-confirm {
            width: 130px;
            background: #3B7DFF;
            color: #fff;
            box-shadow: 0 4px 12px rgba(59, 125, 255, 0.35);

            &:hover {
                background: #5a93ff;
            }

            &:active {
                background: #2b6ae8;
            }

            &[disabled] {
                background: #a0c4ff;
                box-shadow: none;
                cursor: not-allowed;
            }
        }

        .btn-full {
            width: 180px;
            height: 50px;
            background: linear-gradient(153deg, #0052FF 0%, #4D7CFF 100%);
            box-shadow: 0px 4px 14px 0px rgba(0, 82, 255, 0.25);
            border-radius: 14px;
            border: 1px solid transparent;

            &:hover {
                background: linear-gradient(153deg, #1a65ff 0%, #6690ff 100%);
            }

            &:active {
                background: linear-gradient(153deg, #0044dd 0%, #3d6be8 100%);
            }

            &[disabled] {
                background: linear-gradient(153deg, #a0bfff 0%, #c4d5ff 100%);
                box-shadow: none;
            }
        }
    }

    // simple 模式
    &.is-simple {
        .dialog-content {
            border-radius: 16px;
        }

        .dialog-body {
            text-align: center;
            padding: 18px 32px 26px;
        }

        .dialog-footer {
            justify-content: center;
            border-top: none;
            padding: 0 28px 28px;
        }
    }
}
</style>
